const pathname = window?.location?.pathname;
// 判断当前页面是否激励
export const isIncentive = () => {
    if (pathname.indexOf('/share/incentive') === 0) {
        return true;
    }
    return false;
};
